import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, LogOut, Sparkles } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { cn } from "../lib/utils";

const NAV = [
  { to: "/dashboard", label: "Panoramica", icon: LayoutDashboard, end: true },
  { to: "/dashboard/projects", label: "Progetti", icon: Sparkles },
];

const ROLE_LABEL = {
  super_admin: "Super Admin",
  member: "Membro",
};

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="flex h-screen bg-canvas">
      {/* Sidebar */}
      <aside className="flex w-64 flex-col border-r border-line bg-white" data-testid="sidebar">
        <div className="flex h-16 items-center gap-2 border-b border-line px-5">
          <div className="flex h-8 w-8 items-center justify-center bg-brand text-white">
            <Sparkles className="h-5 w-5" />
          </div>
          <div className="leading-tight">
            <p className="font-display text-sm font-extrabold tracking-tight text-ink">AVATAR BUILDER</p>
          </div>
        </div>

        <nav className="flex-1 space-y-1 px-3 py-4">
          {NAV.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={`nav-${it.label.toLowerCase()}`}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-3 px-3 py-2.5 text-sm font-medium transition-colors",
                  isActive
                    ? "bg-brand text-white"
                    : "text-slate-600 hover:bg-slate-100 hover:text-ink"
                )
              }
            >
              <it.icon className="h-4 w-4" />
              {it.label}
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-line p-3">
          <div className="mb-3 px-2">
            <p className="truncate text-sm font-semibold text-ink" data-testid="current-user-name">
              {user?.name}
            </p>
            <p className="truncate text-xs text-slate-400">{ROLE_LABEL[user?.role] || user?.role}</p>
          </div>
          <Button
            variant="outline"
            className="w-full justify-start"
            onClick={handleLogout}
            data-testid="logout-btn"
          >
            <LogOut className="h-4 w-4" /> Esci
          </Button>
        </div>
      </aside>

      {/* Content */}
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col gap-4 border-b border-line bg-white px-8 py-6 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="font-display text-2xl font-black tracking-tight text-ink">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
